import { filter, isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { PromotionalCtaList, Service } from '../../../../../types/__codegen__/sanity/graphql';
import { WithOrderIndex } from '../types';
import getContentTilesData from '../../../../explained-term/detail/utils/get-content-tiles-data';

type Tile = {
  type: string;
};
type MapTilesContentProps = {
  cmsSectionContent: WithOrderIndex<PromotionalCtaList>;
};

const mapTilesContent = ({ cmsSectionContent }: MapTilesContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const tilesData = cmsSectionContent?.items;
  const serviceTiles = filter((tileType: Tile) => tileType.type === 'service', tilesData) as Service[];
  const contentTiles = getContentTilesData({ serviceTiles });
  return {
    contentTiles,
    orderIndex: cmsSectionContent.orderIndex,
    type: CONTENT_SECTIONS.PROMOTIONAL_TILES,
  };
};

export default mapTilesContent;
